<template>
	<v-app style="background: #eee" class="pa-3">
		<div>
			<span class="display-1 font-weight-light"> Accepted </span>
			<v-divider/>
			<br />
			<v-layout row wrap>
				<span v-if="accepted.length==0" class="subheading">You have no accepted requests.</span>
				<v-flex v-for="post in accepted" xs12 sm6 md4>
					<div class="mr-4 ml-4 mt-4">
						<AcceptedCard
							:source=post.data().source
							:destination=post.data().destination
							:posted_by=post.data().posted_by
							:cab_booked=post.data().cab_booked
							:date=post.data().date_time.toDate().toLocaleDateString()
							:time=post.data().date_time.toDate().toLocaleTimeString().substr(0,5)
							:accept_limit=post.data().accept_limit
							:accepted_count=post.data().accepted.length
							:postId=post.id
						></AcceptedCard>
					</div>
				</v-flex>
			</v-layout>
		</div>
		
		<div class="pt-4">
			<span class="display-1 font-weight-light"> Requested </span>
			<v-divider/>
			<br />
			<v-layout row wrap>
				<span v-if="requested.length==0" class="subheading">You have no pending requests.</span>
				<v-flex v-for="post in requested" xs12 sm6 md4>
					<div class="mr-4 ml-4 mt-4">
						<RequestCard
							:source=post.data().source
							:destination=post.data().destination
							:posted_by=post.data().posted_by
							:cab_booked=post.data().cab_booked
							:date=post.data().date_time.toDate().toLocaleDateString()
							:time=post.data().date_time.toDate().toLocaleTimeString().substr(0,5)
							:accept_limit=post.data().accept_limit
							:accepted_count=post.data().accepted.length
							:postId=post.id
						></RequestCard>
					</div>
				</v-flex>
			</v-layout>
		</div>

		<div class="pt-4">
			<span class="display-1 font-weight-light"> Rejected </span>
			<v-divider/>
			<br />
			<v-layout row wrap>
				<span v-if="rejected.length==0" class="subheading">You have no rejected requests.</span>
				<v-flex v-for="post in rejected" xs12 sm6 md4>
					<div class="mr-4 ml-4 mt-4">
						<RequestCard
							:source=post.data().source
							:destination=post.data().destination
							:posted_by=post.data().posted_by
							:cab_booked=post.data().cab_booked
							:date=post.data().date_time.toDate().toLocaleDateString()
							:time=post.data().date_time.toDate().toLocaleTimeString().substr(0,5)
							:accept_limit=post.data().accept_limit
							:accepted_count=post.data().accepted.length
							:postId=post.id
						></RequestCard>
					</div>
				</v-flex>
			</v-layout>
		</div>
	</v-app>
</template>

<script>
import RequestCard from '@/components/RequestCard.vue'
import AcceptedCard from '@/components/AcceptedCard.vue'
import firebase from 'firebase'

export default {
	components:{
		RequestCard,
		AcceptedCard
	},

	data(){
		return {
			listener: null,
			requested: [],
			accepted: [],
			rejected: [],
		}
	},
	beforeDestroy(){
		var vm=this;
		vm.listener();
	},

	created: function(){
		const db = firebase.firestore();
		var vm = this;
		vm.listener = db.collection('users').doc(firebase.auth().currentUser.uid)
		.onSnapshot(function(doc){
			var tempRequested = [];
			var tempAccepted = [];
			var tempRejected = [];
			for (var postId of doc.data().requested){
				db.collection('posts').doc(postId).get()
				.then(function(postDoc){
					tempRequested.push(postDoc)
				})
			}
			for (var postId of doc.data().accepted){
				db.collection('posts').doc(postId).get()
				.then(function(postDoc){
					tempAccepted.push(postDoc)
				})
			}
			for (var postId of doc.data().rejected){
				db.collection('posts').doc(postId).get()
				.then(function(postDoc){
					tempRejected.push(postDoc)
				})
			}
			vm.accepted = tempAccepted;
			vm.rejected = tempRejected;
			vm.requested = tempRequested;
		});
	}
};
</script>
